import React, { useState, useEffect, Component } from 'react';
import {
  Alert,
  Image,
  KeyboardAvoidingView,
  Linking,
  ScrollView,
  Text,
  TouchableHighlight,
  View,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Swipeout from 'react-native-swipeout';
import {iso6393} from 'iso-639-3';
import Styles from './styles';
import Config from './config';
import Hermes from './hermes';

const WordnikURL = `${Config.Scheme}://${Config.Domain}/word`;
const WordsURL = `${Config.Scheme}://${Config.Domain}/words`;
const LICENSE = `from Wiktionary, Creative Commons Attribution/Share-Alike License`;
const LICENSE_URL = `http://creativecommons.org/licenses/by-sa/3.0/`;
const SupportedLanguages = [
  "bul",
  "deu",
  "ell",
  "eng",
  "spa",
  "fin",
  "fra",
  "ind",
  "ita",
  "jpn",
  "lat",
  "lit",
  "mlg",
  "nld",
  "nor",
  "pol",
  "por",
  "rus",
  "hbs",
  "swe",
  "tur"
];

var languages = {};
for (var i = 0; i < iso6393.length; i++) {
  languages[iso6393[i].iso6393] = iso6393[i].name;
}

function Rows(props) {
  const id = props.id;
  const lang = props.lang;
  const entry = props.entry;
  const loading = props.loading;
  const navigation = props.navigation;

  const use = async (partOfSpeech, definition) => {
    const wordID = id;
    const def = {
      wordID: wordID,
      partOfSpeech: partOfSpeech,
      text: definition,
      attributionText: LICENSE,
      attributionUrl: LICENSE_URL,
    };
    try {
      const result = await Hermes.fetch(`${WordsURL}/${wordID}/definition`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "PUT",
        body: JSON.stringify({definition: def}),
      });

      navigation.goBack()
    } catch(error) {
      Hermes.alert(error);
    }
  };

  let rows = [];
  if (entry && ((entry.parts && entry.parts.length > 0) || (entry.relations && Object.keys(entry.relations).length > 0))) {
    const {parts, relations} = entry;
    if (parts && (parts.length > 0)) {
      let key = 0;
      for (const value of parts) {
        const { part, definitions, translations } = value;

        rows.push(
          <Text key={`${key.toString()}`} style={{marginLeft: 5, marginTop: 5, fontWeight: 'bold'}}>{part}</Text>
        );

        if (definitions && (definitions.length > 0)) {
          rows.push(
            <Text key={`${key.toString()}_definitions`} style={{marginLeft: 10, marginTop: 5, fontWeight: 'bold'}}>definitions</Text>
          );
          for (let i = 0; i < definitions.length; i++) {
            rows.push(
              <Swipeout key={`${key.toString()}_${i.toString()}`} left={[
                {
                  text: 'Use',
                  backgroundColor: 'green',
                  onPress: () => use(part, definitions[i])
                },
              ]} backgroundColor={'#ffffff'} autoClose={true}>
                <View style={{marginLeft: 15, marginRight: 5, marginTop: 10}}>
                  <Text>{definitions[i]}</Text>
                  <Text style={{marginTop: 5, color: 'gray', fontSize: 8}}>{LICENSE}</Text>
                </View>
              </Swipeout>
            );
          }
        }

        if (translations) {
          const keys = Object.keys(translations);
          if (keys.length > 0) {
            rows.push(
              <Text key={`${key.toString()}_translations`} style={{marginLeft: 10, marginTop: 5, fontWeight: 'bold'}}>translations</Text>
            );
            for (const k of keys) {
              const supported = SupportedLanguages.indexOf(k) > -1;
              let style = {};
              if (supported) {
                style = {fontWeight: "bold"};
              }
              const v = translations[k];
              rows.push(
                <View key={`${key.toString()}_${k}`} style={{marginLeft: 15, marginRight: 5, marginTop: 10}}>
                  <Text style={style}>{languages[k]}</Text>
                </View>
              );
              if (supported) {
                let subKey = 0;
                for (const translation of v) {
                  const wordnikProps = {
                    id: id,
                    word: translation.replace(/[ ]/g, "_"),
                    lang: k,
                    //wordsView: wordsView,
                  };
                  rows.push(
                    <TouchableHighlight key={`${key.toString()}_${k}_${subKey}_${translation}`}
                      style={{marginLeft: 20, marginRight: 5, marginTop: 10}}
                      onPress={() => navigation.push('Wordnik', wordnikProps, null, `${key.toString()}_${k}_${subKey}_${translation}`)}>
                      <Text>{translation}</Text>
                    </TouchableHighlight>
                  );
                  subKey++;
                }
              } else {
                rows.push(
                  <View key={`${key.toString()}_${k}_translations`}
                    style={{marginLeft: 20, marginRight: 5, marginTop: 10}}>
                    <Text>{v.join(" ")}</Text>
                  </View>
                );
              }
            }
          }
        }
        key++;
      }
    }

    if (relations) {
      const keys = Object.keys(relations);
      if (keys.length > 0) {
        rows.push(
          <Text key={`relations`} style={{marginLeft: 5, marginTop: 5, fontWeight: 'bold'}}>relations</Text>
        );
        for (const k of keys) {
          rows.push(
            <Text key={`${k}_relations`} style={{marginLeft: 10, marginTop: 5, fontWeight: 'bold'}}>{k}</Text>
          );
          for (const relation of relations[k]) {
            const wordnikProps = {
              id: id,
              word: relation,
              lang: lang,
              //wordsView: wordsView,
            };
            const cleaned = relation.replace(/[-_]/g, " ");
            rows.push(
              <Swipeout key={`relation_${k.toString()}_${relation.toString()}`} left={[
                {
                  text: 'Say',
                  backgroundColor: 'blue',
                  onPress: () => window.speechSynthesis.speak(new SpeechSynthesisUtterance(cleaned))
                },
              ]} backgroundColor={'#ffffff'} autoClose={true}>
                <TouchableHighlight key={`${k}_${relation}`}
                  style={{marginLeft: 15, marginRight: 5, marginTop: 10}}
                  onPress={() => navigation.push('Wordnik', wordnikProps, null, `${k}_${relation}`)}>
                  <Text>{cleaned}</Text>
                </TouchableHighlight>
              </Swipeout>
            );
          }
        }
      }
    }
  } else if (loading) {
    rows.push(
      <Text key="1" style={{marginLeft: 5, marginTop: 10, fontWeight: 'bold'}}>Entry loading...</Text>
    );
  } else {
    rows.push(
      <Text key="1" style={{marginLeft: 5, marginTop: 10, fontWeight: 'bold'}}>Entry not found</Text>
    );
  }

  rows.push(<View key={`spacer`} style={{height: 40}}></View>);
  return rows
};

export default function WordnikView({ route, navigation }) {
  var [id, setID] = useState(0);
  var [word, setWord] = useState('');
  var [lang, setLang] = useState('');
  //var [wordsView, setWordsView] = useState(null);
  var [entry, setEntry] = useState(null);
  var [loading, setLoading] = useState(true);

  useEffect(async () => {
    navigation.setOptions({ title: `Word: ${route.params.word}` })
    const helpWordnikView = await AsyncStorage.getItem('help_wordnik_view');
    if (helpWordnikView == null) {
      await AsyncStorage.setItem('help_wordnik_view', 'given');
      window.speechSynthesis.speak(new SpeechSynthesisUtterance("to use a definition swipe right on a definition and select use"));
    }
    try {
      let lang = route.params.lang;
      if (!lang) {
        lang = 'eng';
      }
      const result = await Hermes.fetch(`${WordnikURL}/${route.params.word}?lang=${lang}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "GET",
      });
      setID(route.params.id);
      setWord(route.params.word);
      setLang(lang);
      //setWordsview(route.params.wordsView);
      setEntry(result);
      setLoading(false);
    } catch(error) {
      Hermes.alert(error);
    }
  }, []);

  const wordnik = () => {
    try {
      Linking.openURL(`https://en.wiktionary.org/wiki/${word}`);
    } catch(error) {
      Hermes.alert(error);
    }
  };

  return (
    <View style={Styles.container}>
      <KeyboardAvoidingView behavior={'height'} style={Styles.modal}>
        <ScrollView backgroundColor={'#ffffff'} keyboardShouldPersistTaps='always'>
          <TouchableHighlight
            style={{marginTop: 10, flex: 1, flexDirection: 'row', justifyContent: 'center'}}
            onPress={wordnik}>
            <Text style={{fontSize: 32, fontWeight: 'bold'}}>Wiktionary</Text>
          </TouchableHighlight>
          <Rows id={id} lang={lang} entry={entry} loading={loading} navigation={navigation}/>
        </ScrollView>
      </KeyboardAvoidingView>
    </View>
  );
}
